AED:
    en: 'DH'
    es: 'DH'
    fr: 'DH'
    pt: 'DH'
    ru: 'DH'
AFN:
    en: '؋'
    es: '؋'
    fr: '؋'
    pt: '؋'
    ru: '؋'
ALL:
    en: 'Lek'
    es: 'Lek'
    fr: 'Lek'
    pt: 'Lek'
    ru: 'Lek'
AMD:
    en: '֏'
    es: '֏'
    fr: '֏'
    pt: '֏'
    ru: '֏'
ANG:
    en: 'NAƒ'
    es: 'NAƒ'
    fr: 'NAƒ'
    pt: 'NAƒ'
    ru: 'NAƒ'
AOA:
    en: 'Kz'
    es: 'Kz'
    fr: 'Kz'
    pt: 'Kz'
    ru: 'Kz'
ARS:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
AUD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
AWG:
    en: 'ƒ'
    es: 'ƒ'
    fr: 'ƒ'
    pt: 'ƒ'
    ru: 'ƒ'
AZN:
    en: '₼'
    es: '₼'
    fr: '₼'
    pt: '₼'
    ru: '₼'
BAM:
    en: 'KM'
    es: 'KM'
    fr: 'KM'
    pt: 'KM'
    ru: 'KM'
BBD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
BDT:
    en: '৳'
    es: '৳'
    fr: '৳'
    pt: '৳'
    ru: '৳'
BGN:
    en: 'лв.'
    es: 'лв.'
    fr: 'лв.'
    pt: 'лв.'
    ru: 'лв.'
BHD:
    en: 'BD'
    es: 'BD'
    fr: 'BD'
    pt: 'BD'
    ru: 'BD'
BIF:
    en: 'FBu'
    es: 'FBu'
    fr: 'FBu'
    pt: 'FBu'
    ru: 'FBu'
BMD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
BND:
    en: 'B$'
    es: 'B$'
    fr: 'B$'
    pt: 'B$'
    ru: 'B$'
BOB:
    en: '$b'
    es: '$b'
    fr: '$b'
    pt: '$b'
    ru: '$b'
BOV:
    en: 'BOV'
    es: 'BOV'
    fr: 'BOV'
    pt: 'BOV'
    ru: 'BOV'
BRL:
    en: 'R$'
    es: 'R$'
    fr: 'R$'
    pt: 'R$'
    ru: 'R$'
BSD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
BTN:
    en: 'Nu.'
    es: 'Nu.'
    fr: 'Nu.'
    pt: 'Nu.'
    ru: 'Nu.'
BWP:
    en: 'P'
    es: 'P'
    fr: 'P'
    pt: 'P'
    ru: 'P'
BYR:
    en: 'p.'
    es: 'p.'
    fr: 'p.'
    pt: 'p.'
    ru: 'p.'
BZD:
    en: 'BZ$'
    es: 'BZ$'
    fr: 'BZ$'
    pt: 'BZ$'
    ru: 'BZ$'
CAD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
CDF:
    en: 'FC'
    es: 'FC'
    fr: 'FC'
    pt: 'FC'
    ru: 'FC'
CHF:
    en: 'SFr.'
    es: 'SFr.'
    fr: 'SFr.'
    pt: 'SFr.'
    ru: 'SFr.'
CLF:
    en: 'UF'
    es: 'UF'
    fr: 'UF'
    pt: 'UF'
    ru: 'UF'
CLP:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
CNH:
    en: '¥'
    es: '¥'
    fr: '¥'
    pt: '¥'
    ru: '¥'
CNY:
    en: '¥'
    es: '¥'
    fr: '¥'
    pt: '¥'
    ru: '¥'
COP:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
COU:
    en: 'COU'
    es: 'COU'
    fr: 'COU'
    pt: 'COU'
    ru: 'COU'
CRC:
    en: '₡'
    es: '₡'
    fr: '₡'
    pt: '₡'
    ru: '₡'
CUC:
    en: 'CUC$'
    es: 'CUC$'
    fr: 'CUC$'
    pt: 'CUC$'
    ru: 'CUC$'
CUP:
    en: '$MN'
    es: '$MN'
    fr: '$MN'
    pt: '$MN'
    ru: '$MN'
CVE:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
CZK:
    en: 'Kč'
    es: 'Kč'
    fr: 'Kč'
    pt: 'Kč'
    ru: 'Kč'
DJF:
    en: 'Fdj'
    es: 'Fdj'
    fr: 'Fdj'
    pt: 'Fdj'
    ru: 'Fdj'
DKK:
    en: 'kr'
    es: 'kr'
    fr: 'kr'
    pt: 'kr'
    ru: 'kr'
DOP:
    en: 'RD$'
    es: 'RD$'
    fr: 'RD$'
    pt: 'RD$'
    ru: 'RD$'
DZD:
    en: 'DA'
    es: 'DA'
    fr: 'DA'
    pt: 'DA'
    ru: 'DA'
EGP:
    en: 'E£'
    es: 'E£'
    fr: 'E£'
    pt: 'E£'
    ru: 'E£'
ERN:
    en: 'Nfk'
    es: 'Nfk'
    fr: 'Nfk'
    pt: 'Nfk'
    ru: 'Nfk'
ETB:
    en: 'Br'
    es: 'Br'
    fr: 'Br'
    pt: 'Br'
    ru: 'Br'
EUR:
    en: '€'
    es: '€'
    fr: '€'
    pt: '€'
    ru: '€'
FJD:
    en: 'FJ$'
    es: 'FJ$'
    fr: 'FJ$'
    pt: 'FJ$'
    ru: 'FJ$'
FKP:
    en: 'FK£'
    es: 'FK£'
    fr: 'FK£'
    pt: 'FK£'
    ru: 'FK£'
GBP:
    en: '£'
    es: '£'
    fr: '£'
    pt: '£'
    ru: '£'
GEL:
    en: '₾'
    es: '₾'
    fr: '₾'
    pt: '₾'
    ru: '₾'
GGP:
    en: '£'
    es: '£'
    fr: '£'
    pt: '£'
    ru: '£'
GHS:
    en: '₵'
    es: '₵'
    fr: '₵'
    pt: '₵'
    ru: '₵'
GIP:
    en: '£'
    es: '£'
    fr: '£'
    pt: '£'
    ru: '£'
GMD:
    en: 'D'
    es: 'D'
    fr: 'D'
    pt: 'D'
    ru: 'D'
GNF:
    en: 'FG'
    es: 'FG'
    fr: 'FG'
    pt: 'FG'
    ru: 'FG'
GTQ:
    en: 'Q'
    es: 'Q'
    fr: 'Q'
    pt: 'Q'
    ru: 'Q'
GYD:
    en: 'GY$'
    es: 'GY$'
    fr: 'GY$'
    pt: 'GY$'
    ru: 'GY$'
HKD:
    en: 'HK$'
    es: 'HK$'
    fr: 'HK$'
    pt: 'HK$'
    ru: 'HK$'
HNL:
    en: 'L'
    es: 'L'
    fr: 'L'
    pt: 'L'
    ru: 'L'
HRK:
    en: 'kn'
    es: 'kn'
    fr: 'kn'
    pt: 'kn'
    ru: 'kn'
HTG:
    en: 'G'
    es: 'G'
    fr: 'G'
    pt: 'G'
    ru: 'G'
HUF:
    en: 'Ft'
    es: 'Ft'
    fr: 'Ft'
    pt: 'Ft'
    ru: 'Ft'
IDR:
    en: 'Rp'
    es: 'Rp'
    fr: 'Rp'
    pt: 'Rp'
    ru: 'Rp'
ILS:
    en: '₪'
    es: '₪'
    fr: '₪'
    pt: '₪'
    ru: '₪'
IMP:
    en: 'M£'
    es: 'M£'
    fr: 'M£'
    pt: 'M£'
    ru: 'M£'
INR:
    en: '₹'
    es: '₹'
    fr: '₹'
    pt: '₹'
    ru: '₹'
IQD:
    en: 'ID'
    es: 'ID'
    fr: 'ID'
    pt: 'ID'
    ru: 'ID'
IRR:
    en: 'Rl.'
    es: 'Rl.'
    fr: 'Rl.'
    pt: 'Rl.'
    ru: 'Rl.'
ISK:
    en: 'kr'
    es: 'kr'
    fr: 'kr'
    pt: 'kr'
    ru: 'kr'
JEP:
    en: '£'
    es: '£'
    fr: '£'
    pt: '£'
    ru: '£'
JMD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
JOD:
    en: 'JD'
    es: 'JD'
    fr: 'JD'
    pt: 'JD'
    ru: 'JD'
JPY:
    en: '¥'
    es: '¥'
    fr: '¥'
    pt: '¥'
    ru: '¥'
KES:
    en: 'KSh'
    es: 'KSh'
    fr: 'KSh'
    pt: 'KSh'
    ru: 'KSh'
KGS:
    en: 'K.S.'
    es: 'K.S.'
    fr: 'K.S.'
    pt: 'K.S.'
    ru: 'K.S.'
KHR:
    en: '៛'
    es: '៛'
    fr: '៛'
    pt: '៛'
    ru: '៛'
KMF:
    en: 'CF'
    es: 'CF'
    fr: 'CF'
    pt: 'CF'
    ru: 'CF'
KPW:
    en: '₩'
    es: '₩'
    fr: '₩'
    pt: '₩'
    ru: '₩'
KRW:
    en: '₩'
    es: '₩'
    fr: '₩'
    pt: '₩'
    ru: '₩'
KWD:
    en: 'K.D.'
    es: 'K.D.'
    fr: 'K.D.'
    pt: 'K.D.'
    ru: 'K.D.'
KYD:
    en: 'CI$'
    es: 'CI$'
    fr: 'CI$'
    pt: 'CI$'
    ru: 'CI$'
KZT:
    en: '₸'
    es: '₸'
    fr: '₸'
    pt: '₸'
    ru: '₸'
LAK:
    en: '₭'
    es: '₭'
    fr: '₭'
    pt: '₭'
    ru: '₭'
LBP:
    en: 'L£'
    es: 'L£'
    fr: 'L£'
    pt: 'L£'
    ru: 'L£'
LKR:
    en: 'Rs'
    es: 'Rs'
    fr: 'Rs'
    pt: 'Rs'
    ru: 'Rs'
LRD:
    en: 'L$'
    es: 'L$'
    fr: 'L$'
    pt: 'L$'
    ru: 'L$'
LSL:
    en: 'L'
    es: 'L'
    fr: 'L'
    pt: 'L'
    ru: 'L'
LYD:
    en: 'LD'
    es: 'LD'
    fr: 'LD'
    pt: 'LD'
    ru: 'LD'
MAD:
    en: 'Dh'
    es: 'Dh'
    fr: 'Dh'
    pt: 'Dh'
    ru: 'Dh'
MDL:
    en: 'MDL'
    es: 'MDL'
    fr: 'MDL'
    pt: 'MDL'
    ru: 'MDL'
MGA:
    en: 'Ar'
    es: 'Ar'
    fr: 'Ar'
    pt: 'Ar'
    ru: 'Ar'
MKD:
    en: 'ден'
    es: 'ден'
    fr: 'ден'
    pt: 'ден'
    ru: 'ден'
MMK:
    en: 'K'
    es: 'K'
    fr: 'K'
    pt: 'K'
    ru: 'K'
MNT:
    en: '₮'
    es: '₮'
    fr: '₮'
    pt: '₮'
    ru: '₮'
MOP:
    en: 'MOP$'
    es: 'MOP$'
    fr: 'MOP$'
    pt: 'MOP$'
    ru: 'MOP$'
MRO:
    en: 'UM'
    es: 'UM'
    fr: 'UM'
    pt: 'UM'
    ru: 'UM'
MUR:
    en: 'Rs'
    es: 'Rs'
    fr: 'Rs'
    pt: 'Rs'
    ru: 'Rs'
MVR:
    en: 'Rf'
    es: 'Rf'
    fr: 'Rf'
    pt: 'Rf'
    ru: 'Rf'
MWK:
    en: 'MK'
    es: 'MK'
    fr: 'MK'
    pt: 'MK'
    ru: 'MK'
MXN:
    en: 'Mex$'
    es: 'Mex$'
    fr: 'Mex$'
    pt: 'Mex$'
    ru: 'Mex$'
MXV:
    en: 'MXV'
    es: 'MXV'
    fr: 'MXV'
    pt: 'MXV'
    ru: 'MXV'
MYR:
    en: 'RM'
    es: 'RM'
    fr: 'RM'
    pt: 'RM'
    ru: 'RM'
MZN:
    en: 'MT'
    es: 'MT'
    fr: 'MT'
    pt: 'MT'
    ru: 'MT'
NAD:
    en: 'N$'
    es: 'N$'
    fr: 'N$'
    pt: 'N$'
    ru: 'N$'
NGN:
    en: '₦'
    es: '₦'
    fr: '₦'
    pt: '₦'
    ru: '₦'
NIO:
    en: 'C$'
    es: 'C$'
    fr: 'C$'
    pt: 'C$'
    ru: 'C$'
NOK:
    en: 'kr'
    es: 'kr'
    fr: 'kr'
    pt: 'kr'
    ru: 'kr'
NPR:
    en: 'Rps'
    es: 'Rps'
    fr: 'Rps'
    pt: 'Rps'
    ru: 'Rps'
NZD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
OMR:
    en: 'RO'
    es: 'RO'
    fr: 'RO'
    pt: 'RO'
    ru: 'RO'
PAB:
    en: 'B/.'
    es: 'B/.'
    fr: 'B/.'
    pt: 'B/.'
    ru: 'B/.'
PEN:
    en: 'S/.'
    es: 'S/.'
    fr: 'S/.'
    pt: 'S/.'
    ru: 'S/.'
PGK:
    en: 'K'
    es: 'K'
    fr: 'K'
    pt: 'K'
    ru: 'K'
PHP:
    en: '₱'
    es: '₱'
    fr: '₱'
    pt: '₱'
    ru: '₱'
PKR:
    en: 'Re.'
    es: 'Re.'
    fr: 'Re.'
    pt: 'Re.'
    ru: 'Re.'
PLN:
    en: 'zł'
    es: 'zł'
    fr: 'zł'
    pt: 'zł'
    ru: 'zł'
PYG:
    en: '₲'
    es: '₲'
    fr: '₲'
    pt: '₲'
    ru: '₲'
QAR:
    en: 'QR'
    es: 'QR'
    fr: 'QR'
    pt: 'QR'
    ru: 'QR'
RON:
    en: 'RON'
    es: 'RON'
    fr: 'RON'
    pt: 'RON'
    ru: 'RON'
RSD:
    en: 'd./д.'
    es: 'd./д.'
    fr: 'd./д.'
    pt: 'd./д.'
    ru: 'd./д.'
RUB:
    en: '₽'
    es: '₽'
    fr: '₽'
    pt: '₽'
    ru: '₽'
RWF:
    en: 'FRw'
    es: 'FRw'
    fr: 'FRw'
    pt: 'FRw'
    ru: 'FRw'
SAR:
    en: 'SR'
    es: 'SR'
    fr: 'SR'
    pt: 'SR'
    ru: 'SR'
SBD:
    en: 'SI$'
    es: 'SI$'
    fr: 'SI$'
    pt: 'SI$'
    ru: 'SI$'
SCR:
    en: 'SR'
    es: 'SR'
    fr: 'SR'
    pt: 'SR'
    ru: 'SR'
SDG:
    en: 'SDG'
    es: 'SDG'
    fr: 'SDG'
    pt: 'SDG'
    ru: 'SDG'
SEK:
    en: 'kr'
    es: 'kr'
    fr: 'kr'
    pt: 'kr'
    ru: 'kr'
SGD:
    en: 'S$'
    es: 'S$'
    fr: 'S$'
    pt: 'S$'
    ru: 'S$'
SHP:
    en: '£'
    es: '£'
    fr: '£'
    pt: '£'
    ru: '£'
SLL:
    en: 'Le'
    es: 'Le'
    fr: 'Le'
    pt: 'Le'
    ru: 'Le'
SOS:
    en: 'Sh.So.'
    es: 'Sh.So.'
    fr: 'Sh.So.'
    pt: 'Sh.So.'
    ru: 'Sh.So.'
SPL:
    en: 'SPL'
    es: 'SPL'
    fr: 'SPL'
    pt: 'SPL'
    ru: 'SPL'
SRD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
SSP:
    en: 'SSP'
    es: 'SSP'
    fr: 'SSP'
    pt: 'SSP'
    ru: 'SSP'
STD:
    en: 'Db'
    es: 'Db'
    fr: 'Db'
    pt: 'Db'
    ru: 'Db'
SVC:
    en: '₡'
    es: '₡'
    fr: '₡'
    pt: '₡'
    ru: '₡'
SYP:
    en: '£S'
    es: '£S'
    fr: '£S'
    pt: '£S'
    ru: '£S'
SZL:
    en: 'L'
    es: 'L'
    fr: 'L'
    pt: 'L'
    ru: 'L'
THB:
    en: '฿'
    es: '฿'
    fr: '฿'
    pt: '฿'
    ru: '฿'
TJS:
    en: 'TJS'
    es: 'TJS'
    fr: 'TJS'
    pt: 'TJS'
    ru: 'TJS'
TMT:
    en: 'T'
    es: 'T'
    fr: 'T'
    pt: 'T'
    ru: 'T'
TND:
    en: 'DT'
    es: 'DT'
    fr: 'DT'
    pt: 'DT'
    ru: 'DT'
TOP:
    en: 'T$'
    es: 'T$'
    fr: 'T$'
    pt: 'T$'
    ru: 'T$'
TRY:
    en: '₺'
    es: '₺'
    fr: '₺'
    pt: '₺'
    ru: '₺'
TTD:
    en: 'TT$'
    es: 'TT$'
    fr: 'TT$'
    pt: 'TT$'
    ru: 'TT$'
TVD:
    en: 'TV$'
    es: 'TV$'
    fr: 'TV$'
    pt: 'TV$'
    ru: 'TV$'
TWD:
    en: 'NT$'
    es: 'NT$'
    fr: 'NT$'
    pt: 'NT$'
    ru: 'NT$'
TZS:
    en: 'TSh'
    es: 'TSh'
    fr: 'TSh'
    pt: 'TSh'
    ru: 'TSh'
UAH:
    en: '₴'
    es: '₴'
    fr: '₴'
    pt: '₴'
    ru: '₴'
UGX:
    en: 'USh'
    es: 'USh'
    fr: 'USh'
    pt: 'USh'
    ru: 'USh'
USD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
UYU:
    en: '$U'
    es: '$U'
    fr: '$U'
    pt: '$U'
    ru: '$U'
UZS:
    en: 'U.S.'
    es: 'U.S.'
    fr: 'U.S.'
    pt: 'U.S.'
    ru: 'U.S.'
VEF:
    en: 'Bs.'
    es: 'Bs.'
    fr: 'Bs.'
    pt: 'Bs.'
    ru: 'Bs.'
VND:
    en: '₫'
    es: '₫'
    fr: '₫'
    pt: '₫'
    ru: '₫'
VUV:
    en: 'VT'
    es: 'VT'
    fr: 'VT'
    pt: 'VT'
    ru: 'VT'
WST:
    en: 'WS$'
    es: 'WS$'
    fr: 'WS$'
    pt: 'WS$'
    ru: 'WS$'
XAF:
    en: 'FCFA'
    es: 'FCFA'
    fr: 'FCFA'
    pt: 'FCFA'
    ru: 'FCFA'
XAG:
    en: 'Ag'
    es: 'Ag'
    fr: 'Ag'
    pt: 'Ag'
    ru: 'Ag'
XAU:
    en: 'Au'
    es: 'Au'
    fr: 'Au'
    pt: 'Au'
    ru: 'Au'
XBT:
    en: 'BTC'
    es: 'BTC'
    fr: 'BTC'
    pt: 'BTC'
    ru: 'BTC'
XCD:
    en: '$'
    es: '$'
    fr: '$'
    pt: '$'
    ru: '$'
XDR:
    en: 'XDR'
    es: 'XDR'
    fr: 'XDR'
    pt: 'XDR'
    ru: 'XDR'
XOF:
    en: 'F'
    es: 'F'
    fr: 'F'
    pt: 'F'
    ru: 'F'
XPD:
    en: 'Pd'
    es: 'Pd'
    fr: 'Pd'
    pt: 'Pd'
    ru: 'Pd'
XPF:
    en: 'F'
    es: 'F'
    fr: 'F'
    pt: 'F'
    ru: 'F'
XPT:
    en: 'PT'
    es: 'PT'
    fr: 'PT'
    pt: 'PT'
    ru: 'PT'
YER:
    en: 'Rl'
    es: 'Rl'
    fr: 'Rl'
    pt: 'Rl'
    ru: 'Rl'
ZAR:
    en: 'R'
    es: 'R'
    fr: 'R'
    pt: 'R'
    ru: 'R'
ZMW:
    en: 'K'
    es: 'K'
    fr: 'K'
    pt: 'K'
    ru: 'K'
